import { fcaGateWay } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";

export const getLeaseBuildings = params => fcaGateWay.get(`${serviceEndpoints.leaseEndPoints.getLeases}`, { params });

export const addBuildingLease = params => fcaGateWay.post(`${serviceEndpoints.leaseEndPoints.lease}`, params);

export const updateBuildingLease = (id, params) => fcaGateWay.patch(`${serviceEndpoints.leaseEndPoints.lease}/${id}`, params);

export const deleteBuildingLease = id => fcaGateWay.delete(`${serviceEndpoints.leaseEndPoints.lease}/${id}`);

export const getLeaseBuildingsById = (lease_id, params) => fcaGateWay.get(`${serviceEndpoints.leaseEndPoints.lease}/${lease_id}`, { params });

export const getLeaseBuildingsDynamicFields = params => fcaGateWay.get(`${serviceEndpoints.leaseEndPoints.getDynamicField}`, { params });

export const getListForCommonFilter = params =>
    fcaGateWay.get(`${serviceEndpoints.leaseEndPoints.lease}/get_list`, {
        params
    });
